module.exports = __webpack_public_path__ + "img/slide-down.51fa2c7b.svg";